import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDeveloppeurFullStack = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          💻 Recruter un Développeur Full-Stack
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Développeur Full-Stack maîtrise à la fois le front-end (interface utilisateur) et le back-end (logique serveur, base de données) d’une application web ou mobile. Véritable profil polyvalent, il est capable de concevoir une application de A à Z, ce qui en fait un atout clé pour les projets agiles, les MVP ou les refontes globales de plateformes digitales.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Développement d’applications web ou mobile (front + back)</li>
          <li>Intégration de bases de données et d’API tierces</li>
          <li>Mise en place de systèmes d’authentification, de paiement, etc.</li>
          <li>Optimisation des performances, SEO technique et responsive design</li>
          <li>Participation à l’architecture technique et au choix des technologies</li>
          <li>Maintenance évolutive et corrective</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Front-end : HTML, CSS, JavaScript, React / Vue / Angular</li>
          <li>Back-end : Node.js, PHP, Python, Java, Ruby, etc.</li>
          <li>Bases de données : MySQL, PostgreSQL, MongoDB</li>
          <li>Outils DevOps : Git, Docker, CI/CD</li>
          <li>Bonne culture produit et UX/UI</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : capable de développer des fonctionnalités simples en autonomie</li>
          <li>Confirmé : projets complets en production, maîtrise de la stack choisie</li>
          <li>Senior : architecte applicatif, référent technique ou CTO freelance</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior / Architecte : 650–850 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDeveloppeurFullStack;
